module.exports = __webpack_public_path__ + "static/media/student-card-img.54834b51.png";